import React, { useState } from "react";
import { Skeleton } from "antd";

export default function SkeletonImage({ ...props }) {
  const [isLoaded, SetIsLoaded] = useState(false);
  return (
    <div>
      {!isLoaded && (
        <Skeleton.Image
          active={true}
          width={props.width || 200}
          height={props.height || 300}
        />
      )}
      <img
        {...props}
        onLoad={() => {
          SetIsLoaded(true);
        }}
        style={!isLoaded ? { display: "none" } : {}}
      />
    </div>
  );
}
